

$('.second-carousel').owlCarousel({
    loop: true,
    margin: 20,
    dots: false,
    nav: true,
    responsive: {
        0: {
            items: 1
        },
        768: {
            items: 2
        },
        1000: {
            items: 3
        },
        1300: {
            items: 4
        }
    }
});
$('.third-carousel').owlCarousel({
    loop: true,
    margin: 20,
    dots: false,
    nav: true,
    responsive: {
        0: {
            items: 2
        },
        768: {
            items: 3
        },
        1000: {
            items: 5
        }
    }
});
$(document).ready(function() {
    $('.selectpicker').selectpicker();
});

